import axios from 'axios';
import { API_VIRSION } from 'config';

export const getCouponCodes = (params) =>
  axios.get(`${API_VIRSION}/admin/approval/code`, { params });

export const createCouponCode = (body) => axios.post(`${API_VIRSION}/admin/approval/code`, body);
